import { KYMW1317Model } from '../kymw1317.model';
import { ApprovalItemModel } from '../vo/kymw1317-approval-item.model';
import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 企画連絡承認画面　承認項目一覧を取得するサービス
 *
 * @export ApprovalItemService
 * @class ApprovalItemService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class ApprovalItemService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1317Model}
   * @memberof ApprovalItemService
   */
  private model: KYMW1317Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {ApprovalItemModel}
   * @memberof ApprovalItemService
   */
  private vo: ApprovalItemModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof ApprovalItemService
   */
  private successFunc: Function;

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof ApprovalItemService
   */
  private getBody(): PlessRequest {

    const coopInformation = [];
    this.vo.coopInformation.forEach((coop) => {
      coopInformation.push({
        parameter: {
          ItemCode: coop.itemCode,
          MessageFromCoop: coop.messageFromCoop,
        }
      })
    });

    const approvalColumn = [];
    this.vo.approvalColumnList.forEach((col) => {
      approvalColumn.push({
        parameter: {
          ItemCode: col.itemCode,
          ColumnNo: col.columnNo,
          CodeDiv: col.codeDiv,
          CodeSeqNo: col.codeSeqNo,
          OperationType: col.operationType,
          SkewerSelect: col.skewerSelect,
        }
      })
    });

    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        PCode: this.vo.pCode,
        EditorSelect: this.vo.editorSelect,
        BuyerSelect: this.vo.buyerSelect,
      },
      update: {
        CoopInformation: {
          combination: coopInformation
        },
        ApprovalColumnList: {
          combination: approvalColumn
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof ApprovalItemService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1317Model>model;
    this.vo = <ApprovalItemModel>vo;
    this.successFunc = successFunc;
    this.send('approvalItem', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof ApprovalItemService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }

}
